export default __webpack_public_path__ + "static/media/activate.97893bcf.png";